import SalesProfitMarginPreview from "./SalesProfitMarginPreview";

const PrintSalesProfitMargin: React.FC = () => {
  return (
    <div className="inner-container">
      <SalesProfitMarginPreview />
    </div>
  );
};

export default PrintSalesProfitMargin;
